import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

import styled from "styled-components";

import { faQuestionCircle } from "@fortawesome/pro-solid-svg-icons";
import FnrTypography from "UI/FnrTypography";
import { AnimatePresence, motion } from "motion/react";

import FnrWarningBox from "UI/FnrWarningBox";
import { explode, inOutMotion } from "UI/motionStyles";

import { use2FAState } from "../../API/queryHooks";

const HelpMessage = () => {
  const [{ message }] = use2FAState();
  const showContactInfoHelpLink = message?.includes(
    "couldn't find a login associated with that"
  );

  const [explodeIt] = useState(0.1 > Math.random());

  return (
    <AnimatePresence>
      {Boolean(message) && (
        <motion.div
          {...(explodeIt ? explode : inOutMotion)}
          exit={inOutMotion.exit}
        >
          <SFnrWarningBox data-cy="TwoFA_HelpMessage">
            <FnrTypography color="textWarning">
              {message}
              {showContactInfoHelpLink && (
                <>
                  {" "}
                  <HelpLink
                    href="https://help.flocknote.com/article/50-how-do-i-setup-a-login"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Need help with login setup?"
                    title="Need help?"
                  >
                    <HelpIcon icon={faQuestionCircle} />
                  </HelpLink>
                </>
              )}
            </FnrTypography>
          </SFnrWarningBox>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default HelpMessage;

const SFnrWarningBox = styled(FnrWarningBox)`
  margin-top: 16px;
`;

const HelpLink = styled.a`
  display: inline-flex;
  align-items: center;
  margin-left: 1px;
  color: #000000a7 !important;
  text-decoration: none;
  opacity: 1;
  transition: color 150ms;
  translate: 0 2px;

  &:hover {
    color: #000000 !important;
  }
`;

const HelpIcon = styled(FontAwesomeIcon)`
  font-size: 17px;
`;
